export class TaxEstimate {
    id: string;
    planId: string;
    planYear: any;
    priorYearTax: any;
    priorYearAGI: any;
    currentYearTax: any;
    currentYearAGI: any;
    filingStatus: string;
    notes: string;
    status: string;
  
    constructor(
      _id: string = '',
      _planId: string = '',
      _planYear: any = '',
      _priorYearTax: any = '',
      _priorYearAGI: any = '',
      _currentYearTax: any = '',
      _currentYearAGI: any = '',
      _filingStatus: string = '',
      _notes: string = '',
      _status: string = ''
    ) {
      this.id = _id;
      this.planId = _planId;
      this.planYear = _planYear;
      this.priorYearTax = _priorYearTax;
      this.priorYearAGI = _priorYearAGI;
      this.currentYearTax = _currentYearTax;
      this.currentYearAGI = _currentYearAGI;
      this.filingStatus = _filingStatus;
      this.notes = _notes;
      this.status = _status;
    }
  
    static createDefaultProjections(): Array<TaxEstimateProjection> {
      return [
        new TaxEstimateProjection('Federal 1040 Tax Projection'),
        new TaxEstimateProjection('State Personal Tax Projection'),
        new TaxEstimateProjection('C-Corp Federal Tax Projection', true),
        new TaxEstimateProjection('C-Corp State Tax Projection', true)
      ];
    }
  }
  
  export class TaxEstimateProjection {
    id: string;
    estimateId: string;
    projectionName: string;
    notes: string;
    recommendedEstimates: any;
    paidEstimates: any;
  
    safeHarbor: any;
    priorYearTaxDue: any;
    currentYearExpectedMinTaxDue: any;
    minimumAmountDueToIRS: any;
  
    overPaymentAppliedForPY: any;
    estimatedW2WithHolding: any;
    estimatedW2WithHoldingSpouse: any;
  
    quarter1: any;
    quarter2: any;
    quarter3: any;
    quarter4: any;
    addittionalPayment1: any;
    addittionalPayment2: any;
    extensionPayment: any;
  
    remainderDueRefund: any;
    isRemainderDueOrRefundNegative: boolean;
  
    constructor(name: string, includeDueDate: boolean = false) {
      this.id = '';
      this.estimateId = '';
      this.projectionName = name;
      this.notes = '';
      this.recommendedEstimates = '';
      this.paidEstimates = '';
  
      // Leave computed/display-only fields blank by default
      this.safeHarbor = '';
      this.priorYearTaxDue = '';
      this.currentYearExpectedMinTaxDue = '';
      this.minimumAmountDueToIRS = '';
  
      this.overPaymentAppliedForPY = '';
      this.estimatedW2WithHolding = '';
      this.estimatedW2WithHoldingSpouse = '';
  
      const q = () => includeDueDate
        ? {dueDate: '', recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''}
        : {recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''};
  
      this.quarter1 = q();
      this.quarter2 = q();
      this.quarter3 = q();
      this.quarter4 = q();
      this.addittionalPayment1 = q();
      this.addittionalPayment2 = q();
      this.extensionPayment = q();
  
      this.remainderDueRefund = '';
      this.isRemainderDueOrRefundNegative = false;
    }
  }